import React from "react";

export const Project = ({ title, link, image, description}) => {

  return (
    <div className="portfolio-item">
      <div className="hover-bg project-bg">
        <a href={link} target="_blank" rel="noopener noreferrer" title={title}>
          <div className="hover-text">
          <h4>View Article on Medium</h4>
          </div>
          <img src={image} className="project-img img-responsive" alt={title} />
          <h4>{title}</h4>
          <p>{description}</p>
        </a>
      </div>

    </div>
  );
};